import { render, staticRenderFns } from "./plusOrder.vue?vue&type=template&id=1436cb47&scoped=true&lang=html"
import script from "./plusOrder.vue?vue&type=script&lang=js"
export * from "./plusOrder.vue?vue&type=script&lang=js"
import style0 from "./plusOrder.vue?vue&type=style&index=0&id=1436cb47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1436cb47",
  null
  
)

export default component.exports